module.exports = __webpack_public_path__ + "static/mountain-scene-37cef8f7d5ae368dff82f852aa134c12.png";